import { render, staticRenderFns } from "./Objective.vue?vue&type=template&id=52cffe5e&scoped=true"
import script from "./Objective.vue?vue&type=script&lang=js"
export * from "./Objective.vue?vue&type=script&lang=js"
import style0 from "./Objective.vue?vue&type=style&index=0&id=52cffe5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cffe5e",
  null
  
)

export default component.exports